import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { alertError, alertSuccess } from '../../components/Toast';
import {
  fetchExternalView,
  sendExternalAction,
} from '../../core/utils/externalLinks';
import ModalExternalOS from '../../screens/ModalExternalOS/ModalExternalOS';

const ExternalOSContainer = () => {
  const location = useLocation();
  let history = useHistory();
  const token = location.pathname.split('/')[2];
  const [values, setValues] = useState({});
  const [client, setClient] = useState([]);
  const [vehicle, setVehicle] = useState([]);
  const [service, setService] = useState([]);
  const [aeService, setAeService] = useState([]);
  const [parts, setParts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [printCompany, setPrintCompany] = useState({});
  const [consultant, setConsultant] = useState(null);
  const [checklist, setChecklist] = useState([]);

  const loadData = async () => {
    const { data, error } = await fetchExternalView('os', token);
    if (error || !data?.record) {
      history.push('/login');
      return;
    }
    const { record, client: clientRows, company, vehicles } = data;
    setValues(record);
    setService(JSON.parse(record.service) || []);
    setAeService(JSON.parse(record.ae_service) || []);
    setParts(JSON.parse(record.parts) || []);
    setClient(
      (clientRows || []).map((item) => ({ label: item.name, value: item.id }))
    );
    setVehicle(
      (vehicles || []).map((item) => ({
        label: `${item.brand} / ${item.model} / ${item.plate}`,
        value: item.id,
      }))
    );
    if (company) setPrintCompany(company);
    if (data.consultant) {
      setConsultant({ label: data.consultant.name, value: data.consultant.id });
    }
    setChecklist(data.checklist || []);
  };

  useEffect(() => {
    loadData();
  }, [token]);

  const approve = async () => {
    setLoading(true);
    const { data, error } = await sendExternalAction('os', token, 'approve');
    setLoading(false);

    if (!error) {
      setValues(data[0]);
      alertSuccess('Ordem de serviço aprovada com sucesso!');
    } else {
      alertError('Erro ao aprovar ordem de serviço!');
    }
  };

  const analyse = async () => {
    setLoading(true);
    const { data, error } = await sendExternalAction('os', token, 'analyse');
    setLoading(false);

    if (!error) {
      setValues(data[0]);
      alertSuccess('Ordem de serviço em análise');
    } else {
      alertError('Erro, tente mais tarde!');
    }
  };

  const inDoubt = async () => {
    setLoading(true);
    const { data, error } = await sendExternalAction('os', token, 'doubt');
    setLoading(false);

    if (!error) {
      setValues(data[0]);
      alertSuccess('Ordem de serviço em análise');
    } else {
      alertError('Erro, tente mais tarde!');
    }
  };

  return (
    <>
      <ModalExternalOS
        printCompany={printCompany}
        values={values}
        client={client}
        vehicle={vehicle}
        service={service}
        aeService={aeService}
        parts={parts}
        loading={loading}
        inDoubt={inDoubt}
        analyse={analyse}
        approve={approve}
        consultant={consultant}
        checklist={checklist}
      />
    </>
  );
};

export default ExternalOSContainer;
